import type { Identifier } from "@medplum/fhirtypes";

/**
 * Identifier system used to embed a practice name on ProjectMembership at invite time.
 * This lets the profile selector show the practice label without needing auth.
 */
export const MEMBERSHIP_PRACTICE_NAME_SYSTEM = "vibrant.membership.practice-name";

/**
 * Builds an Identifier with the practice name for membership metadata.
 */
export function buildPracticeNameIdentifier(
  practiceName: string | undefined,
): Identifier | undefined {
  if (!practiceName?.trim()) {
    return undefined;
  }
  return { system: MEMBERSHIP_PRACTICE_NAME_SYSTEM, value: practiceName.trim() };
}
